import React from 'react';
import { AddTo } from '@thd-olt-component-react/add-to';
import { extend } from '@thd-nucleus/data-sources';
import proptypes from 'prop-types';

const { number, string } = proptypes;

export const BuyboxAddToProject = ({ quantity, itemId }) => {
  return (
    <AddTo
      addToType="Project"
      products={[{ itemId, quantity }]}
    />
  );
};

BuyboxAddToProject.dataModel = extend(
  AddTo
);

BuyboxAddToProject.defaultProps = {
  quantity: 1,
};

BuyboxAddToProject.propTypes = {
  quantity: number,
  itemId: string.isRequired,
};
